import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { Button } from '@/components/atoms'
import { ButtonType } from '@/components/atoms/button'
import { createSelfCheckinBaseStyle, createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

type LanguageType = 'ja' | 'en' | 'zh' | 'ko'

const languages: { code: LanguageType; label: string }[] = [
  { code: 'ja', label: '日本語' },
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' },
  { code: 'ko', label: '한국어' },
]

export const LanguageSelect: React.FC<{ drawerCss?: any }> = ({ drawerCss }) => {
  const { i18n } = useTranslation()

  const changeLanguage = (language: LanguageType): void => {
    i18n.changeLanguage(language)
    localStorage.setItem('lang', language)
  }

  useEffect(() => {
    const language = localStorage.getItem('lang')
    if (language) i18n.changeLanguage(language)
  }, [])

  return (
    <div css={buttonBoxStyle}>
      {languages.map(language => (
        <Button
          key={language.code}
          width={80}
          height={48}
          buttonType={i18n.language === language.code ? ButtonType.Primary : ButtonType.Secondary}
          onClick={() => changeLanguage(language.code)}
        >
          {language.label}
        </Button>
      ))}
    </div>
  )
}

const buttonBoxStyle = css(
  {
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoFlow: 'column',
    alignItems: 'center',
    gap: 16,
    width: 'max-content',
  },
  createSelfCheckinBaseStyle({
    '> button': {
      width: 80,
      height: 48,
      padding: '14px 16px',
      borderRadius: 40,
      fontSize: 14,
      fontWeight: 400,
      whiteSpace: 'nowrap',
    },
  }),
  createSelfCheckinResponsiveStyle({
    landscape13: {
      '> button': {
        width: 94,
        height: 54,
        padding: '15px 16px 14px',
        fontSize: 18,
      },
    },
  }),
)
